// extracted by mini-css-extract-plugin
export default {"headerBar":"NewEmployee_headerBar__E5NvK"};